
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorClosedHandIcon as ObiCursorClosedHandIconElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-closed-hand-icon.js';
 
 
 

 
 export const ObiCursorClosedHandIcon = createComponent({
   react: React,
   tagName: 'obi-cursor-closed-hand-icon',
   elementClass: ObiCursorClosedHandIconElement,
   events: {
     
   }
  });
 
 